import { jsx } from 'panel';
import { ScrollControlEl } from 'common/widgets/scroll-control';
import { FunnelOverviewPanelEl } from 'common/report/widgets/funnels/overview-panel';
import { FunnelsChartEl } from 'common/widgets/funnels-chart';
import { SpinnerEl } from 'common/components/spinner';
import { FunnelsTableEl } from 'common/widgets/funnels-table';
import { ChartLegendEl } from 'common/components/chart-legend';
export function template() {
  var _a;

  const columnWidth = this.attr("chart-attrs")["column-width"];
  const columnGridGap = this.attr("chart-attrs")["column-grid-gap"];
  const scrollBy = columnWidth + columnGridGap;
  return jsx("div", {
    sel: '.context-chart'
  }, jsx("div", {
    sel: '.step-chart',
    style: Object.assign({}, this.attr("chart-height") ? {
      height: "".concat(this.attr("chart-height"), "px")
    } : {})
  }, jsx(ScrollControlEl, {
    attrs: Object.assign({
      // 95% allows it to be split in half between chart/table in funnels
      top: "95%",
      // Calculated by taking the width offset of the overview (218) + FunnelsChartSizing.yAxisContainerWidth + 8px padding for the button itself
      left: "277px",
      'scroll-by': scrollBy,
      'interrupt-workaround-delay': 50
    }, this.attr("scroll-control-offsets")),
    props: {
      scrollEl: (_a = this.state.stepChart) === null || _a === void 0 ? void 0 : _a.getScrollBox(),
      mousemoveEl: this._mouseMoveEl
    }
  }), jsx("div", {
    sel: [".step-chart-container", this.attr("legend-attrs") ? ".stacked-overview" : ""].join("")
  }, this.attr("legend-attrs") && jsx(ChartLegendEl, {
    attrs: this.attr("legend-attrs")
  }), jsx("div", {
    sel: '.chart-layout'
  }, !this.attr("hide-overview") && jsx(FunnelOverviewPanelEl, {
    attrs: this.attr("overview-panel-attrs")
  }), jsx(FunnelsChartEl, {
    attrs: this.attr("chart-attrs"),
    props: {
      overallSteps: this._overallSteps
    },
    on: {
      closePopover: this.helpers.passThrough,
      selectBar: this.helpers.passThrough,
      updateStartStep: this.helpers.passThrough,
      scrollBoxMount: this.helpers.chartScrollBoxMount,
      track: this.helpers.passThrough
    }
  }, jsx("slot", {
    attrs: {
      name: "empty-state"
    }
  }))))), this.attr("table-attrs") && jsx("div", {
    sel: '.table.block',
    class: {
      v2: true
    }
  }, jsx("div", {
    sel: '.table-body'
  }, this.attr("table-loading") ? jsx(SpinnerEl, null) : jsx(FunnelsTableEl, {
    attrs: this.attr("table-attrs"),
    props: {
      segmentSteps: this._segmentSteps,
      comparisonSegments: this._comparisonSegments
    },
    on: {
      clickAnalyze: this.helpers.passThrough,
      selectionChange: this.helpers.passThrough,
      changeControlGroup: this.helpers.passThrough,
      scrollBoxMount: this.helpers.tableScrollBoxMount
    }
  }))));
}